import { render, staticRenderFns } from "./ProductionProgress.vue?vue&type=template&id=640ea356&"
import script from "./ProductionProgress.vue?vue&type=script&lang=js&"
export * from "./ProductionProgress.vue?vue&type=script&lang=js&"
import style0 from "./ProductionProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports